import { isNullOrUndefined } from '@vy/utils';
import { useEffect, useRef, useState, RefObject } from 'react';

export function useContainerWidth<ElementType extends HTMLElement>(): [RefObject<ElementType>, number] {
  const containerRef = useRef<ElementType>(null);
  const [width, setWidth] = useState(0);

  const iterateEntriesWidth = (entries: ResizeObserverEntry[]) => {
    for (const entry of entries) {
      if (entry.target === containerRef.current) {
        setWidth(entry.contentRect.width);
      }
    }
  };

  useEffect(() => {
    const element = containerRef.current;
    if (isNullOrUndefined(element)) {
      return;
    }

    const resizeObserver = new ResizeObserver(iterateEntriesWidth);

    resizeObserver.observe(element);
    setWidth(element.offsetWidth);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return [containerRef, width];
}
